import $ from 'jquery';
import _ from 'underscore';
import BaseInput from 'source/lib/component/input/base';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';

const PasswordInput = BaseInput.extend({
    name: 'password-input',
    template,
    initialize(...args) {
        BaseInput.prototype.initialize.apply(this, args);
        if (/.*AppleWebKit/i.test(window.navigator.userAgent)) {
            this.safariFix();
        }
    },

    /*  Safari has a setting "Force store logins and passwords".
    It stores login and password even if web resource forbids to do it.
    If a password field is available on page it triggers Safari to fill
    stored login and password.
    Readonly login field forces Safari to try to fill possible login field
    and it fills captcha field with a password by mistake.*/
    safariFix() {
        const focusInput = $('.js-autofocus');
        const input = this.$('.js-input');

        input.prop('type', 'text');
        focusInput.focus();
        setTimeout(() => {
            input.prop('type', 'password');
            focusInput.focus();
        }, 1000);
    },
    render() {
        const parent = {
            'parent-uId': this.uId || '',
            'parent-name': this.name || ''
        };
        const context = _.extend({ msgs: messages }, Settings.get(), this.data, parent);
        const rendered = this.template(context);
        const $el = $(rendered);

        this.$el.replaceWith($el);
        return rendered;
    }
});

export default PasswordInput;



// WEBPACK FOOTER //
// ./static-source/js/lib/component/input/password/index.js